<template>
    <div class="game-wrapper wrapper">
        <div class="game-inner">
            <div class="game-rain"></div>
            <div class="game-money"></div>
            <div class="game-hb">
                <div class="hb-item" v-for="(item, index) in hbArr" :key="index" :style="{ left: item.left, animationDuration: item.durTime, webkitAnimationDuration: item.durTime}" :class="item.cls" :data-index="index" @webkitAnimationEnd="removeDom" @animationEnd="removeDom">
                    <img class="in" @touchstart="clickHb" src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm274u7m1k1eibtd91sfh34.png" :style="{ transform: item.transforms, webkitTransform: item.transforms}" alt="">
                    <img class="out" src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271d9o7va7i06b214tc38.png" :style="{ transform: item.transforms, webkitTransform: item.transforms}" alt="">
                </div>                
            </div>           
        </div>
    </div>
</template>

<script>

import COVER from '@/utils/COVER'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'game',
    data() {
        return {
            hbArr: [],
            timeId: null,
            timeOutId: null,
            totalTime: 5000,
            clickCount: 0,
            clickTotal: 0,
            timesTotal: 0,
            type: 0
        }
    },
    computed: {
      ...mapState(['aid', 'isImmerse', 'shareData', 'userinfo', 'versionSize'])
    },
    created() {
        let _this = this
        this.type = this.$route.query.type
        this.setMaskDataAsync({
            type: 5,
            text: '亲，点击屏幕上红包，抢现金红包哦！',
            btns: [
                {
                    text: '确定',
                    fn() {
                        _this.setMaskDataAsync(null)
                        _this.setTimes()
                    }
                }
            ]
        })
    },
    mounted() {
        this.checkTimeAsync()
        this.clickTotal = Math.ceil(Math.random() * 5)
        this.share()
        this.setPageLoadingAsync(false)
        document.querySelector('.loading-wrap').style.display = 'none'
    },
    destroyed() {
        clearInterval(this.timeId)
        clearTimeout(this.timeOutId)
        this.setMaskDataAsync(null)
    },
    methods: {
        ...mapActions([
            'setMaskDataAsync',
            'getHbAsync',
            'checkCanGetHb',
            'checkTimeAsync',
            'setPageLoadingAsync'
        ]),
        setTimes() {
            this.hbArr = [] 
            this.timeId = setInterval(()=> {
                if(this.clickCount >= this.clickTotal) {
                    clearInterval(this.timeId)
                    return
                }
                this.addHb()
            }, 150)
            this.timeOutId = setTimeout(()=> {
                this.timeEndMask()
                clearInterval(this.timeId)
            }, this.totalTime)
        },
        addHb() {
            let winW = document.documentElement.clientWidth || document.body.clientWidth
            let left = parseInt(Math.random() * (winW - 50))
            let rotate = (parseInt(Math.random() * 90 - 45)) + "deg";
            let scales = (Math.random() * 5 + 8) * 0.1;
            let durTime = (Math.random() * 2 + 3) + 's';
            this.hbArr.push({left: left+'px', cls: 'ani', transforms: 'rotate('+ rotate +') scale('+ scales +')', durTime: durTime})
        },
        removeDom(e) {
            let target = e.currentTarget;
            document.querySelector('.game-hb').removeChild(target)
        },
        clickHb(e) {
            this.clickCount++
            var item = e.currentTarget.parentNode
            item.className = `${item.className} fade`
            if(this.clickCount == this.clickTotal) {
                clearTimeout(this.timeOutId)
                this.getHbAsync(this.type)
            }
        },
        timeEndMask() {
            let _this = this
            this.timesTotal++
            if(this.timesTotal < 2) {                
                this.setMaskDataAsync({
                    type: 5,
                    text: '亲，再点一次，加油哦！',
                    btns: [
                        {
                            className: 'close-btn',
                            text: '取消',
                            fn() {
                                _this.setMaskDataAsync(null)
                                _this.$router.replace('/')
                            }
                        },
                        {
                            text: '确定',
                            fn() {
                                _this.setMaskDataAsync(null)
                                _this.setTimes()
                            }
                        }
                    ]
                })
            } else {
                this.setMaskDataAsync({
                    type: 5,
                    text: '亲，两次都未抢到红包，请返回首页<br/>再来一次！',
                    btns: [
                        {
                            className: 'arrow-btn',
                            text: '返回首页',
                            fn() {
                                _this.setMaskDataAsync(null)
                                _this.$router.replace('/')
                            }
                        }
                    ]
                })
            }
        },
        share() {
            let _this = this        
            let ShareData = JSON.parse(JSON.stringify(this.shareData))
            ShareData.callback = function(ret) {
                COVER.track(_this.aid, 'share', '分享')         
            }
            if (!this.isImmerse) {
                COVER.share(ShareData)
            }
        }
    }
}
</script>

<style lang="less">
    .game-wrapper {
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27129algom3toh81lmq31.jpg) repeat-y;
        background-position: center top;
        background-size: 100% auto;
        height: 100vh;
        position: relative;
        &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27gji1tdt3h71n931v1d33.jpg) no-repeat center bottom;
            background-size: 100% auto;
        }
    }
    .game-inner {
        position: relative;
        height: 100%;
        overflow: hidden;
        z-index: 1;
        &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 3.792271rem;
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27v1714v7kfqbl510o432.png) no-repeat center bottom;
            background-size: 100% auto;
        }
    }
    .game-rain, .game-money {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271b9010h41narsl8um636.png) left top repeat;
        background-size: cover;
    }
    .game-money {
        background-image: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271f641mpj10jp1h04htg35.png);
    }

    .game-hb {
        height: 100%;
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
    }

    .hb-item {
        width: .966184rem;
        position: absolute;
        top: -2.012882rem;
        cursor: pointer;
        .out {
            opacity: 0;
            position: absolute;
            left: 0;
            top: 0;
            width: 0;
            height: 0;
        }
        &.ani {
            animation: hbMove 1.5s linear forwards;
        }
        &.fade {
            .in {
                opacity: 0;
                transition: all .3s linear;
            }
            .out {
                animation: hbFade 0.7s linear forwards;
            }
        }
    }
    

    @keyframes hbMove {
        0% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
        100% {
            -webkit-transform: translateY(100vh);
            transform: translateY(100vh);
        }
    }

    @keyframes hbFade {
        0% {
            opacity: 0;
            width: 0;
            height: 0;
        }
        50% {
            opacity: 1;
            width: auto;
            height: 100%;
        }
        100% {
            opacity: 0;
            width: auto;
            height: 100%;
        }
    }
</style>